/* import __COLOCATED_TEMPLATE__ from './saas-shared-ui-shim.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import ReactShim from '@square/react-shim/components/react-shim';
import { ShimTag } from '@dashboard/shared-ui/types/shim';
/**
 * Uses the React shim to incorporate React components from the `@squareup/saas-shared-ui`
 * package into Ember.
 *
 * You can specify the container tag by using the exported ENUM `ShimTag`. This allows you
 * to set the shimmed component to be block (`div`) or inline (`span`). Other tag names
 * can/will be added as needed. `div` is the default.
 *
 * Example:
 *
 *  <Saas::SaasSharedUiShim
 *    @componentName="MyReactComponent"
 *    @prop1="value1"
 *    @prop2="value2"
 *    @prop3="value3"
 * />
 *
 * Example using a live SaaS component:
 *
 * <Saas::SaasSharedUiShim
 *    @componentName="UpsellPill"
 *    @featureToken="feature-token"
 *    @size="medium"
 *    @shimTag={{ShimTag.DIV}}
 * />
 */
let SaasSharedUiShim = (_class = class SaasSharedUiShim extends ReactShim {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "queryClient", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "environment", _descriptor3, this);
    _defineProperty(this, "ShimTag", ShimTag);
    _defineProperty(this, "library", () => import('@squareup/saas-shared-ui'));
  }
  get shimTag() {
    if (typeof this.args.shimTag === 'string' || this.args.shimTag instanceof String) {
      return `${this.args.shimTag}`;
    }
    return ShimTag.DIV;
  }
  componentWrapper() {
    return this.library().then(module => {
      return module.SaaSProviderEmberWrapper;
    });
  }
  componentWrapperProps() {
    return {
      queryClient: this.queryClient.instanceV5,
      merchantToken: this.userInfo.merchantToken,
      name: this.userInfo.name,
      countryCode: this.userInfo.countryCode,
      currencyCode: this.userInfo.currencyCode,
      locale: this.userInfo.languageCode,
      environment: this.environment.name
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "queryClient", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SaasSharedUiShim as default };